module.exports = "/_next/static/images/9d75fcba7c44c33405e4180238c9857b-debit-pre-ric.svg";